import axios from "axios";

export default async function getProjects(){
    const res =  await axios.get("/projects");
    return res.data;
}